import { InputLite, withErrorField } from '@bingads-webui-react/primitive-validation-fluent';
import _ from 'underscore';

export const errorMessageMapping = {
  required: _TL_('Field must not be empty'),
  type: _TL_('Invalid Character'),
  maxLength: _TL_('Maximum length exceeded'),
  minLength: _TL_('Minimum length not met'),
  range: _TL_('Number range is incorrect'),
  // [new-i18n-issue]: a workaround to use build-in validation string map
  Validation_Base_Field_Not_Valid: _TL_('Validation_Base_Field_Not_Valid'),
  Validation_NotEmpty_Required_Field: _TL_('Validation_NotEmpty_Required_Field'),
  Validation_String_Max_Length: _TL_('Validation_String_Max_Length'),
  Validation_String_Min_Length: _TL_('Validation_String_Min_Length'),
  Validation_String_Invalid_Characters: _TL_('Validation_String_Invalid_Characters'),
  Validation_Number_Require_Numeric: _TL_('Validation_Number_Require_Numeric'),
  Validation_Number_Max_Length: _TL_('Validation_Number_Max_Length'),
  Validation_Number_Range_Min: _TL_('Validation_Number_Range_Min'),
  Validation_Number_Range_Max: _TL_('Validation_Number_Range_Max'),
  Validation_Number_Range_Between: _TL_('Validation_Number_Range_Between'),
};

export const handleValidationMessages = (i18n, errors, customErrorMapping = errorMessageMapping) => {
  const errorStrings = _.map(
    errors,
    (oldError, key) => (
      _.has(customErrorMapping, key) ?
        i18n.getString(customErrorMapping[key]) : oldError)
  );
  return _.isEmpty(errorStrings) ? [] : [_.last(errorStrings)];
};

export const ValidatedInput = withErrorField(InputLite);

